import React from "react";
import { COPY } from "@/copy";

export const Footer = () => (
  <footer className="bg-ds-ink text-ds-bone">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-14 grid grid-cols-1 md:grid-cols-12 gap-8">
      <div className="md:col-span-5">
        <div className="ds-display text-3xl mb-3">
          DateSpeak<span className="text-ds-flame">.</span>
        </div>
        <p className="text-ds-bone/60 leading-relaxed text-sm max-w-md">
          {COPY.footer_disc}
        </p>
      </div>
      <div className="md:col-span-7 md:text-right">
        <div className="ds-mono text-[10px] uppercase tracking-[0.3em] text-ds-bone/40">
          {COPY.footer_rights}
        </div>
        <div className="ds-mono text-[10px] uppercase tracking-[0.3em] text-ds-bone/40 mt-2">
          built for adults. read your gut.
        </div>
        <div className="ds-mono text-[11px] tracking-wide text-ds-bone/70 mt-4">
          Built by Ankit Vengurlekar — Co-Host of{" "}
          <a
            href="https://open.spotify.com/show/1SW2viiIiTnnKN28QG4Siz?si=1d5a73f9ed29433a"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-podcast-link"
            className="text-ds-flame hover:text-ds-bone underline underline-offset-2 transition-colors"
          >
            &ldquo;Love Aaj Kal&rdquo; podcast
          </a>
          .
        </div>
      </div>
    </div>
  </footer>
);
